import React from "react";
import { useRenderTemplateWithCollections } from "../MacroBindingContext";

export interface MacroLinkBlockProps {
  text: string;
  href: string;
  title?: string;
}

const MacroLinkBlock = {
  label: "Link",
  llmDescription: `An inline hyperlink for email content.
- 'text' (string): The link display text
- 'href' (string): The URL to link to
- 'title' (string, optional): Tooltip text for the link
- Supports {{variable}} placeholders in both text and href
- Inside repeaters, also supports collection bindings like {{program.Name}}, {{room.RoomType}}
- Use {{QuoteLink}} for the reservation quote URL
- Renders as an <a> element with target="_blank" for external links`,
  fields: {
    text: {
      type: "text" as const,
      label: "Link Text",
    },
    href: {
      type: "text" as const,
      label: "URL",
    },
    title: {
      type: "text" as const,
      label: "Title (tooltip)",
    },
  },
  defaultProps: {
    text: "Click here",
    href: "https://phuketfit.com",
    title: "",
  },
  render: (props: MacroLinkBlockProps) => {
    const render = useRenderTemplateWithCollections();
    const renderedText = render(props.text);
    const renderedHref = render(props.href);
    const renderedTitle = props.title ? render(props.title) : undefined;

    return (
      <a
        href={renderedHref}
        title={renderedTitle}
        target="_blank"
        rel="noopener noreferrer"
      >
        {renderedText}
      </a>
    );
  },
};

export default MacroLinkBlock;
